import { ScheduleEventType } from '@soniq/schema-scheduling'

export const SCHEDULE_PATH = 'schedule'
export const VISIBLE_SCHEDULE_TYPES = [
  ScheduleEventType.generic,
  ScheduleEventType.lesson
]
